module.exports = __webpack_public_path__ + "img/paihuo_touxiang_default.7ea9e0d7.png";